import React, { Component, PropTypes } from 'react'
import _ from 'lodash'
// Services
import api from '../../apiClient/v1'
// Styles
import * as css from './nominaIG.css'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'
// Componentes
import ReactNotify from 'react-notify'
import Modal from 'react-bootstrap/lib/Modal.js'
import { FormularioUsuario } from './components/FormularioUsuario.jsx'
import { PanelDatos } from './components/PanelDatos.jsx'
import { PanelEstados } from './components/PanelEstados.jsx'
import { PanelCaptadorSEI, PanelDetainer } from './components/PanelCaptador.jsx'
import { ModalDireccion } from '../../admin/mantenedorLocales2/Modales.jsx'
import { ModalMasTiempo } from './components/Modales.jsx'

export class NominaIG extends Component {
    constructor(props) {
        super(props)
        this.state = {
            alternateLeaders: [],
            showModalNuevoUsuario: false,
            showModalSuspendOperator: false,
            showModalBlockOperador: false,
            RUNbuscado: '',
            operatorSuspend: '',
            blockOperador: '',
            idNomina: '',
            esTitular: true,
            nomina: this.props.nomina,
            quitarOperador: false,
            nuevoOperador: false,
            modalGPS: false,
            showModalMasTiempo: false,
            cantUserPermisoMall: 0
        }
        this.ajaxErrorHandler = (errorTitle) => {
            return (err) => {
                if (err.status == 500)
                    return this.refs.notificator.error("Error critico en el servidor", "Contactese con el departamento de informática.", 4 * 1000);
                //CODIGO 420 DEL ENROQUE DE OPERADORES
                if (err.status == 420) {
                    let msgs = _.values(err.data.error.idNomina)
                    return this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
                }
                // en otro error, buscar el cuerpo del mensaje
                let msgs = _.values(err.data)
                this.refs.notificator.error(errorTitle, msgs, 4 * 1000);
            }
        }
        this.cancelFormNewUser = () => {
            this.setState({ showModalNuevoUsuario: false })
        }
        this.cancelSuspendOperator = () => {
            this.setState({ showModalSuspendOperator: false })
        }
        this.cancelBlockOperador = () => {
            this.setState({ showModalBlockOperador: false })
        }
        this.cancelModalGPS = () => {
            this.setState({ modalGPS: false })
        }
        this.cancelModalMasTiempo = () => {
            this.setState({ showModalMasTiempo: false })
        }
        this.onNewUser = (datos) => {
            let banco = this.props.bancos.find(banco => banco.nombreCorto == datos.banco)
            let tipoCuenta = this.props.tipoCuentas.find(cuenta => cuenta.nombreCuenta == datos.tipoCuenta)
            datos.banco = banco.idBanco;
            datos.tipoCuenta = tipoCuenta.idCuenta;

            api.usuarios.nuevoOperador(datos)
                .then(usuario => {
                    api.nomina(this.props.nomina.idNomina).agregarOperador(usuario.usuarioRUN, this.state.esTitular, 1)
                        .then(response => {
                            let nominaActualizada = response.data
                            let statusCode = response.status
                            if (statusCode == 204) {
                                console.log("RUN no existe, mostrando formulario")
                                // this.setState({
                                //     showModalNuevoUsuario: true,
                                //     RUNbuscado: run,
                                // })
                                this.refs.notificator.info("Nómina", "No existe Usuario", 4 * 1000);
                            } else if (statusCode == 200) {
                                this.refs.notificator.success("Nómina", "Usuario agregado correctamente", 4 * 1000);
                                this.setState({ nomina: nominaActualizada })
                            }
                            else if (statusCode == 205) {
                                this.refs.notificator.info("Nóminas", "Operador pendiente de aprobación", 4 * 1000);
                                // this.setState({nomina: nominaActualizada})
                            }
                            else if (statusCode == 203) {
                                this.refs.notificator.info("Nóminas", "Operador pendiente de firma de contrato", 4 * 1000);
                                // this.setState({nomina: nominaActualizada})
                            }
                            else if (statusCode == 206) {
                                this.refs.notificator.info("Nóminas", "Operador pendiente de firma de contrato", 4 * 1000);
                                // this.setState({nomina: nominaActualizada})
                            }
                        })
                        .catch(this.ajaxErrorHandler('Agregar Operador'))
                    this.setState({ showModalNuevoUsuario: false })
                })
                .catch(err => {
                    console.log(err)
                    alert(err.data)
                })
        }
        this.getAlternateLeaders = () => {
            api.nomina(this.state.nomina.idNomina).getAlternateLeaders()
                .then(resp => {
                    this.setState({
                        alternateLeaders: resp
                    })
                })
                .catch(errr => console.log(errr))
        }
        // notify
        this.notifyStoreInMall = () => {
            if (this.props.nomina.local_mall)
                this.refs.notificator.info("Atención", "Para su información el local se encuentra en un MALL.", 6 * 1000)
        }
        this.notifyPendingApprovals = () => {
            if (this.state.nomina.operadoresPendientes && this.state.nomina.idEstadoNomina == 4)
                this.refs.notificator.info("Nómina", "La nómina tiene operadores pendientes de aprobación", 6 * 1000)
        }
        this.notifyMoreTime = () => {
            if (this.state.nomina && this.state.nomina.mas_tiempo.length > 0)
                this.setState({ showModalMasTiempo: true })
        }
        // status lists functions
        this.sendList = () => {
            const existeUsuarioConEstadoContrato1 = this.state.nomina.captadorSEI.dotacionTitular.some(usuario => usuario.idEstadoContrato !== 2);
            // if (existeUsuarioConEstadoContrato1) {
            //     console.log("Existe un usuario con contrato pendiente o expirado");
            //     this.refs.notificator.error("Nómina", "La nómina tiene operadores con contrato no resuelto", 6 * 1000)
            // } else {
            return api.nomina(this.state.nomina.idNomina).enviar()
                .then(nomina => {
                    this.setState({ nomina })
                })
                .catch(this.ajaxErrorHandler('error al enviar nomina'))
            // }
        }
        this.approveList = () => {
            return api.nomina(this.state.nomina.idNomina).aprobar()
                .then(nomina => {
                    this.setState({ nomina }, () => this.state.nomina.operadoresPendientes ? this.refs.notificator.info("Nómina", "La nómina tiene operadores pendientes de aprobación", 6 * 1000) : null)
                })
                .catch(this.ajaxErrorHandler('error al aprobar nomina'))
        }
        this.rejectList = () => {
            return api.nomina(this.state.nomina.idNomina).rechazar()
                .then(nomina => {
                    this.setState({ nomina })
                })
                .catch(this.ajaxErrorHandler('error al rechazar nomina'))
        }
        this.reportList = () => {
            return api.nomina(this.state.nomina.idNomina).informar()
                .then(nomina => {
                    this.setState({ nomina })
                })
                .catch(this.ajaxErrorHandler('Error al informar nomina'))
        }
        this.completeWithoutEmail = () => {
            return api.nomina(this.state.nomina.idNomina).completarSinCorreo()
                .then(nomina => {
                    this.setState({ nomina })
                })
                .catch(this.ajaxErrorHandler('Error al informar nomina sin correo'))
        }
        this.rectifyList = () => {
            return api.nomina(this.state.nomina.idNomina).rectificar()
                .then(nomina => {
                    this.setState({ nomina })
                })
                .catch(this.ajaxErrorHandler('Error al rectificar nomina'))
        }
        this.suspendBy = (idOperator, idReason) => {
            api.usuario(idOperator).suspend(idReason)
                .then(resp => {
                    this.removeOperator(idOperator, false)
                    this.cancelSuspendOperator()
                })
                .catch(this.ajaxErrorHandler('error al suspender operador'))
        }
        this.blockOperador = (idOperator, idNomina) => {
            /*api.usuario(idOperator).bloquearTitular(idNomina)
                .then(nomina => {
                    //this.removeOperator(idOperator, true)
                    //this.bloqueoLog(idOperator)
                    this.cancelBlockOperador()
                    console.log('usuario bloqueado')
                    this.setState({nomina})
                })
                .catch(this.ajaxErrorHandler('Error al bloquear operador'))*/
        }
        /*this.bloqueoLog = (idOperator) => {
            api.nomina(this.props.nomina.idNomina).bloqueoLog(idOperator)
                .then(nomina=>{
                    console.log('log creado')
                    this.setState({nomina})
                })
                .catch(this.ajaxErrorHandler('error al crear log'))
        }*/
        this.removeOperator = (idOperator, isTitular) => {
            api.nomina(this.props.nomina.idNomina).quitarOperador(idOperator, isTitular)
                .then(nomina => {
                    console.log('dotacion actualizada')
                    this.setState({ nomina }, () => this.calcularUsuariosPermisoMall())
                })
                .catch(this.ajaxErrorHandler('error al quitar el operador'))
        }
        this.quitarOperadoresMasivo = (data) => {
            let operadores = data.filter((operador) => {
                return operador.status == true;
            });
            console.log('quitar operadores masivo', operadores)
            api.nomina(this.props.nomina.idNomina).quitarOperadoresMasivo(operadores)
                .then(nomina => {
                    console.log('dotacion actualizada')
                    this.setState({ nomina }, () => this.calcularUsuariosPermisoMall())
                })
                .catch(this.ajaxErrorHandler('error al quitar el operador'))
        }
        this.operadorTitularMasivo = (data) => {
            let operadores = data.filter((operador) => {
                return operador.status == true;
            });
            console.log('operadores titulares masivo', operadores)
            api.nomina(this.props.nomina.idNomina).operadorTitularMasivo(operadores)
                .then(nomina => {
                    console.log('dotacion actualizada')
                    this.setState({ nomina }, () => this.calcularUsuariosPermisoMall())
                })
                .catch(this.ajaxErrorHandler('error al agregar de titular al operador'))
        }
        this.enrocarOperadores = (titulares, reemplazos) => {
            api.nomina(this.props.nomina.idNomina).enrocarOperadores(titulares, reemplazos)
                .then(nomina => {
                    console.log('enroque exitoso, dotacion actualizada')
                    this.setState({ nomina }, () => this.calcularUsuariosPermisoMall())
                })
                .catch(this.ajaxErrorHandler('Enrocar operadores'))
        }
        this.operadorEscondido = (idUser) => {
            api.nomina(this.props.nomina.idNomina).operadorEscondido(idUser)
                .then(nomina => {
                    console.log('operador escondido exitoso, nomina actualizada')
                    this.setState({ nomina }, () => this.calcularUsuariosPermisoMall())
                })
                .catch(this.ajaxErrorHandler('Operador Escondido'))
        }
        this.geolocalizacion = (id, lat, lng) => {
            return api.nomina(this.state.nomina.idNomina).agregarGPS(id, lat, lng)
                .then(nomina => {
                    console.log('dirección guardada con exito, local actualizado')
                    this.setState({ nomina })
                })
                .catch(this.ajaxErrorHandler('Error al agregar GPS de local'))
        }
        this.handleMasTiempo = (id, confirma) => {
            return api.nomina(this.state.nomina.idNomina).masTiempoConfirmacion(id, confirma)
                .then(nomina => {
                    console.log('Operación exitosa');
                    this.setState({ nomina })
                })
                .catch(this.ajaxErrorHandler('Error al asignar más tiempo para confirmar'))
        }
        this.calcularUsuariosPermisoMall = () => {
            let cantUserPermisoMall = 0;
            if (this.state.nomina.lider && this.state.nomina.lider.incluir_permisomall) {
                cantUserPermisoMall++
            }
            if (this.state.nomina.supervisor && this.state.nomina.supervisor.incluir_permisomall) {
                cantUserPermisoMall++
            }

            this.state.nomina.captadorSEI.dotacionTitular.map((operador) => {
                if ((this.state.nomina.lider != null && operador.id == this.state.nomina.lider.id) || (this.state.nomina.supervisor != null && operador.id == this.state.nomina.supervisor.id)) {
                    return null;
                }
                if (operador.incluir_permisomall) {
                    cantUserPermisoMall++
                }
            });
            this.state.nomina.captadorSEI.dotacionReemplazo.map((operador) => {
                if ((this.state.nomina.lider != null && operador.id == this.state.nomina.lider.id) || (this.state.nomina.supervisor != null && operador.id == this.state.nomina.supervisor.id)) {
                    return null;
                }
                if (operador.incluir_permisomall) {
                    cantUserPermisoMall++
                }
            });

            /*this.state.nomina.captadorSEI.dotacionEscondida.map((operador) => {
                if ((this.state.nomina.lider != null && operador.id == this.state.nomina.lider.id) || (this.state.nomina.supervisor != null && operador.id == this.state.nomina.supervisor.id)) {
                    return null;
                }
                if (operador.incluir_permisomall) {
                    cantUserPermisoMall++
                }
            });*/
            this.setState({ cantUserPermisoMall })
        }
    }
    // Context API
    getChildContext() {
        return {
            // modificar lider
            agregarLider: (run) => {
                if (run === '')
                    return console.log('RUN vacio, no se hace nada')
                api.nomina(this.props.nomina.idNomina).agregarLider(run)
                    .then(nomina => {
                        this.refs.notificator.success("Nómina", "Lider agregado", 4 * 1000);
                        this.setState({ nomina })
                    })
                    .catch(this.ajaxErrorHandler('Error al asignar el Lider'))
            },
            quitarLider: () => {
                api.nomina(this.props.nomina.idNomina).quitarLider()
                    .then(nomina => {
                        console.log('lider quitado correctamente')
                        this.setState({ nomina })
                    })
                    .catch(this.ajaxErrorHandler('Error al quitar el Lider'))
            },
            // modificar supervisor
            agregarSupervisor: (run) => {
                if (run === '')
                    return console.log('RUN vacio, no se hace nada')
                api.nomina(this.props.nomina.idNomina).agregarSupervisor(run)
                    .then(nomina => {
                        this.refs.notificator.success("Nómina", "Supervisor agregado", 4 * 1000);
                        this.setState({ nomina }, () => this.calcularUsuariosPermisoMall())
                    })
                    .catch(this.ajaxErrorHandler('Error al asignar el Supervisor'))
            },
            quitarSupervisor: () => {
                api.nomina(this.props.nomina.idNomina).quitarSupervisor()
                    .then(nomina => {
                        console.log('dotacion actualizada')
                        this.setState({ nomina }, () => this.calcularUsuariosPermisoMall())
                    })
                    .catch(this.ajaxErrorHandler('Error al quitar el Supervisor'))
            },
            // modificar dotacion
            agregarOperador: (esTitular, idCaptador, run) => {
                console.log(esTitular, idCaptador, run)
                if (run === '') {
                    return console.log('RUN vacio, no se hace nada');
                }
                let request = api.nomina(this.props.nomina.idNomina).agregarOperador(run, esTitular, idCaptador)
                request
                    .then(response => {
                        let nominaActualizada = response.data
                        let statusCode = response.status

                        // si no se encuentra el usuario, se debe mostrar el formulario para crear uno
                        if (statusCode == 204) {
                            console.log("RUN no existe, mostrando formulario")
                            // this.setState({
                            //     showModalNuevoUsuario: true,
                            //     RUNbuscado: run,
                            //     esTitular
                            // })
                            this.refs.notificator.error("Nómina", "Usuario no encontrado", 4 * 1000);
                        }
                        // else if (statusCode == 205) {
                        //     this.refs.notificator.error("Nómina", "Usuario pendiente de aprobación", 4 * 1000);
                        //     // this.setState({nomina: nominaActualizada})
                        // }
                        // else if (statusCode == 203) {
                        //     this.refs.notificator.error("Nómina", "Operador pendiente de firmar contrato", 4 * 1000);
                        //     // this.setState({nomina: nominaActualizada})
                        // }
                        else if (statusCode == 200) {
                            console.log(response);
                            this.refs.notificator.success("Nómina", "Usuario agregado correctamente", 4 * 1000);
                            this.setState({ nomina: nominaActualizada }, () => this.calcularUsuariosPermisoMall())
                        }
                    })
                    .catch(this.ajaxErrorHandler('Agregar Operador'))
                return request
            },
            addAlternateLeader: (run) => {
                if (run === '') {
                    return console.log('RUN vacio, no se hace nada');
                }
                let request = api.nomina(this.props.nomina.idNomina).addAlternateLeader(run)
                request
                    .then(response => {
                        let nominaActualizada = response.data
                        this.refs.notificator.success("Nómina", "Lider suplente agregado correctamente", 4 * 1000);
                        this.setState({ nomina: nominaActualizada })

                    })
                    .catch(this.ajaxErrorHandler('Agregar Lider Suplente'))
                return request
            },
            quitarOperador: (idUsuario, esTitular) => {
                console.log('quitar usuario', idUsuario)
                api.nomina(this.props.nomina.idNomina).quitarOperador(idUsuario, esTitular)
                    .then(nomina => {
                        console.log('dotacion actualizada')
                        this.setState({ nomina }, () => this.calcularUsuariosPermisoMall())
                    })
                    .catch(this.ajaxErrorHandler('error al quitar el operador'))
            },
            suspendOperator: (operator) => {
                this.setState({ showModalSuspendOperator: true, operatorSuspend: operator })
            },
            blockOperador: (operator, idNomina) => {
                this.setState({ showModalBlockOperador: true, blockOperador: operator, idNomina })
            },
            editarEmailContacto: (emailContacto) => {
                api.nomina(this.props.nomina.idNomina).actualizarEmailContacto(emailContacto)
                    .then(nomina => this.setState({ nomina }))
                    .catch(error => console.error(error))
            },
            cambiarDePanel: (usuarioRun, esTitular, idCaptador, pendientes = false) => {
                api.nomina(this.props.nomina.idNomina).cambiarDePanel(usuarioRun, esTitular, idCaptador, pendientes)
                    .then(nomina => this.setState({ nomina }, () => this.calcularUsuariosPermisoMall()))
                    .catch(this.ajaxErrorHandler('Agregar Operador'))
            },
            cambiarDePanelPendientes: (usuarioRun, esTitular, idCaptador, pendientes = false) =>
                api.nomina(this.props.nomina.idNomina).cambiarDePanel(usuarioRun, esTitular, idCaptador, pendientes)
                    .then(nomina => {
                        this.setState({ nomina }, () => this.calcularUsuariosPermisoMall())
                        return "ok"
                    })
            // .catch(this.ajaxErrorHandler('Error al agregar operador'))
            ,
            cambioDotacion: (dotacion) => {
                let datos = { 'dotacionOperadores': dotacion, 'desdeNomina': true }
                api.nomina(this.props.nomina.idNomina).actualizar(datos)
                    .then(nomina => {
                        this.setState({ nomina }, () => this.refs.notificator.success("Nómina", "Dotación actualizada", 4 * 1000))
                    })
                    .catch(err => {
                        console.log(err)
                        this.refs.notificator.error("Nómina", "Error al cambiar la dotación", 4 * 1000)
                    })
            },
            //Get operadores disponibles
            getOperadoresDisponibles: () => {
                let request = api.nomina(this.props.nomina.idNomina).getOperadoresDisponibles()
                return request
            },

            updateNomina: (nomina) => {
                this.setState({ nomina })
            },
            quitarEscondido: (id) => {
                api.nomina(this.props.nomina.idNomina).quitarEscondido(id)
                    .then(nomina => {
                        this.setState({ nomina }, () => {
                            this.refs.notificator.success("Nómina", "Dotación actualizada", 4 * 1000)
                            this.calcularUsuariosPermisoMall()})
                    })
                    .catch(err => {
                        console.log(err)
                        this.refs.notificator.error("Nómina", "Error al quitar operador escondido", 4 * 1000)
                    })
            },
            cambiarCaptador: (idUser, idCaptador) => {
                api.nomina(this.props.nomina.idNomina).cambiarCaptador(idUser, idCaptador)
                    .then(nomina => this.setState({ nomina }))
                    .catch(this.ajaxErrorHandler('Cambio de Captador'))
            },
            updateNominaPermisoMall: (idUser, incluir, orden) => {
                this.setState(prevState => ({
                    nomina: {
                        ...prevState.nomina,
                        lider: prevState.nomina.lider != null && prevState.nomina.lider.id == idUser ? { ...prevState.nomina.lider, incluir_permisomall: incluir } : prevState.nomina.lider,
                        supervisor: prevState.nomina.supervisor != null && prevState.nomina.supervisor.id == idUser ? { ...prevState.nomina.supervisor, incluir_permisomall: incluir } : prevState.nomina.supervisor,
                        captadorSEI: {
                            ...prevState.nomina.captadorSEI,
                            dotacionTitular: prevState.nomina.captadorSEI.dotacionTitular.map(operador =>
                                operador.id == idUser ? { ...operador, incluir_permisomall: incluir, orden_permisomall: orden } : operador
                            ),
                            dotacionReemplazo: prevState.nomina.captadorSEI.dotacionReemplazo.map(operador =>
                                operador.id == idUser ? { ...operador, incluir_permisomall: incluir, orden_permisomall: orden } : operador
                            ),
                            dotacionEscondida: prevState.nomina.captadorSEI.dotacionEscondida.map(operador =>
                                operador.id == idUser ? { ...operador, incluir_permisomall: incluir, orden_permisomall: orden } : operador
                            )
                        }
                    }
                }), () => this.calcularUsuariosPermisoMall());
            },
            setPermisosMallNomina: (permisosMall) => {
                this.setState(prevState => ({
                    nomina: {
                        ...prevState.nomina,
                        permisos_mall: prevState.nomina.permisos_mall.map(permiso => {
                            const permisoMall = permisosMall.find(pm => pm.id == permiso.id);
                            return permisoMall ? permisoMall : permiso;
                        })
                    }
                }))
            }
        }
    }

    

    // Mount component
    componentDidMount() {
        this.getAlternateLeaders()
        this.notifyStoreInMall()
        this.notifyPendingApprovals()
        this.notifyMoreTime()
        this.calcularUsuariosPermisoMall();
    }
    abrirModalGPS = () => {
        this.setState({ modalGPS: true });
    };
    render() {
        let sumaUnidades = this.state.nomina.sumaUnidades
        let sumaConteo = this.state.nomina.sumaConteo
        let nominaPendiente = this.state.nomina.idEstadoNomina == 2
        let operadoresAsignados = this.state.nomina.supervisor ? this.state.nomina.dotacionTitular.length + 1 : this.state.nomina.dotacionTitular.length
        let totalAsignados = this.state.nomina.lider ? operadoresAsignados + 1 : operadoresAsignados
        // la nomina tiene todos los captadores asignados? y el total corresponde a lo asignado?
        let nominaCompleta = (this.state.nomina.dotacionTotal == totalAsignados)
        //Difenrencia entre el stock del local y las unidades contadas por los operadores
        let diferenciaUnidades = this.state.nomina.diferenciaUnidades
        let diferenciaConteo = this.state.nomina.diferenciaConteo
        //Diferencia entre total operadores asignados y dotacion
        let difOperadores = this.state.nomina.dotacionOperadores - this.state.nomina.dotacionTitular.length

        let nominaInformada = this.state.nomina.idEstadoNomina == 5
        return (
            <div className="container-fluid">
                <ReactNotify ref='notificator' className={ReactNotifyCSS} />
                <ModalNewUser
                    bancos={this.props.bancos}
                    tipoCuentas={this.props.tipoCuentas}
                    comunas={this.props.comunas}
                    run={this.state.RUNbuscado}
                    cssModal={css.modalAmplio}
                    showModal={this.state.showModalNuevoUsuario}
                    cancelModal={this.cancelFormNewUser}
                    sendFormNewUser={this.onNewUser}
                />
                <ModalSuspendOperator
                    operator={this.state.operatorSuspend}
                    showModal={this.state.showModalSuspendOperator}
                    cancelModal={this.cancelSuspendOperator}
                    suspendBy={this.suspendBy}
                />
                <ModalBlockOperador
                    operator={this.state.blockOperador}
                    idNomina={this.state.idNomina}
                    showModal={this.state.showModalBlockOperador}
                    cancelModal={this.cancelBlockOperador}
                    blockOperador={this.blockOperador.bind(this)}
                />
                {this.state.modalGPS && <ModalDireccion
                    hideModal={this.cancelModalGPS}
                    direccion={this.state.nomina.local_direccion}
                    comuna={this.state.nomina.local_comuna}
                    id={this.state.nomina.local_id}
                    onGuardar={this.geolocalizacion}
                />}
                {this.state.showModalMasTiempo && <ModalMasTiempo
                    hideModal={this.cancelModalMasTiempo}
                    mas_tiempo={this.state.nomina.mas_tiempo}
                    handleMasTiempo={this.handleMasTiempo}
                />}
                <PanelDatos
                    verTodasNominas={this.props.permisos.verTodasNominas}
                    verHistorialNomina={this.props.permisos.verHistorial}
                    cambiarDotacion={this.props.permisos.cambiarDotacion}
                    disminuirDotacion={this.props.permisos.disminuirDotacion}
                    aprobarCambioDotacion={true}
                    nomina={this.state.nomina}
                />
                {this.props.permisos.verTodasNominas ?
                    <PanelCaptadorSEI
                        idNomina={this.state.nomina.idNomina}
                        nivelConteo={this.state.nomina.nivelConteo}
                        message={this.state.nomina.mensaje}
                        captadorSEI={this.state.nomina.captadorSEI}
                        lider={this.state.nomina.lider}
                        alternateLeaders={this.state.alternateLeaders}
                        supervisor={this.state.nomina.supervisor}
                        maximoOperadores={this.state.nomina.dotacionOperadores}
                        sumaUnidades={sumaUnidades}
                        sumaConteo={sumaConteo}
                        diferenciaUnidades={diferenciaUnidades}
                        diferenciaConteo={diferenciaConteo}
                        rectificada={this.state.nomina.rectificada}
                        difOperadores={difOperadores}
                        nuevoOperador={this.state.nuevoOperador}
                        buscarOperadores={this.props.nomina.local_mall && this.state.nomina.rectificada}
                        // permisos (solo puede editar si esta pendente, y es un captador asignado o es un "captador SEI"
                        verNominaAvanzada={this.props.permisos.verNominaAvanzada}
                        verPasajesNomina={this.props.permisos.verPasajesNomina}
                        editarLiderSupervisor={nominaPendiente && this.props.permisos.cambiarLiderSupervisor}
                        editarOperadores={nominaPendiente && this.props.permisos.editarTodasNominas}
                        editarTodasNominas={this.props.permisos.editarTodasNominas}
                        quitarOperadoresMasivo={this.quitarOperadoresMasivo.bind(this)}
                        operadorTitularMasivo={this.operadorTitularMasivo.bind(this)}
                        nominaInformada={nominaInformada}
                        enrocarOperadores={this.enrocarOperadores.bind(this)}
                        nomina={this.state.nomina}
                        cliente={this.state.nomina.idCliente}
                        puedeAsignar={this.props.permisos.asignarOperadoresNuevos}
                        operadorEscondido={this.operadorEscondido.bind(this)}
                        notificator={this.refs.notificator}
                        administraPasajes={this.props.permisos.administraPasajes}
                        cantUserPermisoMall={this.state.cantUserPermisoMall}
                        maxUsuariosPermisosMall={this.state.nomina.max_usuarios_permisos_mall}
                        puedeInformarDisponibilidad={this.props.permisos.informar}
                    />
                    :
                    null
                }
                {this.state.nomina.captadores.map(captador => {
                    let esMiNomina = this.props.permisos.editarIdCaptador == captador.idCaptador

                    return (this.props.permisos.verTodasNominas || esMiNomina) ?
                        <PanelDetainer
                            nivelConteo={this.state.nomina.nivelConteo}
                            message={this.state.nomina.mensaje}
                            key={captador.idCaptador}
                            captador={captador}
                            rectificada={this.state.nomina.rectificada}
                            difOperadores={difOperadores}
                            sumaUnidades={sumaUnidades}
                            sumaConteo={sumaConteo}
                            diferenciaUnidades={diferenciaUnidades}
                            diferenciaConteo={diferenciaConteo}
                            buscarOperadores={this.props.nomina.local_mall && this.state.nomina.rectificada}
                            // permisos (solo puede editar si esta pendente, y es un captador asignado o es un "captador SEI"
                            editarLiderSupervisor={nominaPendiente && this.props.permisos.cambiarLiderSupervisor}
                            editarOperadores={nominaPendiente && (this.props.permisos.editarTodasNominas || esMiNomina)}
                            editarTodasNominas={this.props.permisos.editarTodasNominas}
                            nominaInformada={nominaInformada}
                            enrocarOperadores={this.enrocarOperadores.bind(this)}
                            nomina={this.state.nomina}
                            idNomina={this.state.nomina.idNomina}
                        />
                        :
                        null
                })}
                <PanelEstados
                    idEstado={this.state.nomina.idEstadoNomina}
                    haSidoRectificada={this.state.nomina.rectificada}
                    enviarNomina={this.sendList}
                    aprobarNomina={this.approveList}
                    rechazarNomina={this.rejectList}
                    informarNomina={this.reportList}
                    completarSinCorreo={this.completeWithoutEmail}
                    rectificarNomina={this.rectifyList}
                    nominaCompleta={nominaCompleta}
                    operadoresPendientes={this.state.nomina.operadoresPendientes}
                    rectificaSistema={this.state.nomina.rectificaSistema}
                    cambio_lider={this.state.nomina.cambio_lider}
                    tiene_gps={this.state.nomina.local_gmap_lat !== null && this.state.nomina.local_gmap_lng !== null}
                    abrirModalGPS={this.abrirModalGPS}
                    // permisos
                    permisos={this.props.permisos}
                />
            </div>
        )
    }
}

NominaIG.propTypes = {
    nomina: PropTypes.object.isRequired,
    comunas: PropTypes.arrayOf(PropTypes.object).isRequired,
    // Permisos
    permisos: PropTypes.object.isRequired
}

NominaIG.childContextTypes = {
    agregarLider: PropTypes.func,
    quitarLider: PropTypes.func,
    agregarSupervisor: PropTypes.func,
    quitarSupervisor: PropTypes.func,
    agregarOperador: PropTypes.func,
    quitarOperador: PropTypes.func,
    editarEmailContacto: PropTypes.func,
    cambiarDePanel: PropTypes.func,
    cambiarDePanelPendientes: PropTypes.func,
    cambioDotacion: PropTypes.func,
    getOperadoresDisponibles: PropTypes.func,
    addAlternateLeader: PropTypes.func,
    suspendOperator: PropTypes.func,
    blockOperador: PropTypes.func,
    updateNomina: PropTypes.func,
    quitarEscondido: PropTypes.func,
    cambiarCaptador: PropTypes.func,
    updateNominaPermisoMall: PropTypes.func,
    setPermisosMallNomina: PropTypes.func,
}

const ModalNewUser = ({ bancos, tipoCuentas, comunas, run, cssModal, showModal, cancelModal, sendFormNewUser }) => {
    return (
        <Modal
            show={showModal}
            onHide={cancelModal}
            dialogClassName={cssModal}
        >
            <Modal.Header closeButton>
                <Modal.Title>Nuevo Operador</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormularioUsuario
                    bancos={bancos}
                    tipoCuentas={tipoCuentas}
                    comunas={comunas}
                    RUNbuscado={run}
                    enviarFormulario={sendFormNewUser}
                    cancelarFormulario={cancelModal}
                />
            </Modal.Body>
        </Modal>
    )
}

const ModalSuspendOperator = ({ operator, showModal, cancelModal, suspendBy }) => {
    return (
        <Modal
            show={showModal}
            onHide={cancelModal}
        >
            <Modal.Header closeButton>
                <Modal.Title>Indicar motivo de suspensión operador {operator.nombreCorto}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={`btn-group-vertical ${css.divButtonsSuspend}`}>
                    <button className="btn btn-warning" onClick={() => suspendBy(operator.id, 1)}>Faltas Reiteradas</button>
                    <button className="btn btn-warning" onClick={() => suspendBy(operator.id, 2)}>Inactividad</button>
                    <button className="btn btn-warning" onClick={() => suspendBy(operator.id, 3)}>Baja Producción</button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

const ModalBlockOperador = ({ operator, idNomina, showModal, cancelModal, blockOperador }) => {
    //console.log(idNomina)
    return (
        <Modal
            show={showModal}
            onHide={cancelModal}
        >
            <Modal.Header closeButton>
                <Modal.Title>Esta acción bloqueará a {operator.nombreCorto}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <h5 style={{ textAlign: 'center' }}>Es posible que el operador esté presente en futuras nóminas y será eliminado de estas</h5>
                    <hr />
                    <h5 style={{ textAlign: 'center' }}>Si alguna nómina estaba informada, esta volverá a estado pendiente</h5>
                </div>
                <div className={`btn-group-vertical ${css.divButtonsSuspend}`}>
                    <button className="btn btn-success" onClick={() => blockOperador(operator.id, idNomina)}>Confirmar</button>
                </div>
            </Modal.Body>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./frontEnd/nominas/nominaIG/nominaIG.jsx